import React, { useState, useEffect } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListDialog } from "../shared/listDialog";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { nomService } from '../../services/api/nom.service';
import { utils } from "../../services/helpers/utils";
import { alertService } from '../../services/helpers/alert.service';



export const MMRecordRecomandations = (props) => {

    const row = {
        id: 0,
        idRecomandare: 0,
        idRezolutie: 0,
        recomandare: "",
        idFisa: props.idFisa ?? 0
    };

    const rol = sessionStorage.getItem("rol");

    const [list, setList] = useState([]);
    const [aptitudineDropdown, setAptitudineDropdown] = useState([]);
    const [aptitudineDefaults, setAptitudineDefaults] = useState([]);
    const [aptId, setAptId] = useState(null);

    const [recomandareDropdown, setRecomandareDropdown] = useState([]);
    const [recomandareDefaults, setRecomandareDefaults] = useState([]);
    const [newRow, setNewRow] = useState(row);
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);

    const [searchTerm, setSearchTerm] = useState("");

    // Aduc lista de recomandari
    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getRecommanedations(
                { recordId: props.idFisa }
            ).then(response => {
                if (response) {
                    setList(response);
                    props.setRecomandari(response)
                }
            });
        }
    }, [props.refresh]);


    // Dupa ce le aduc , setez defaulturile
    useEffect(() => {
        nomService.getMMResolutions()
            .then(response => {
                if (response) {
                    setAptitudineDropdown(response);
                }
            });
    }, [list]);

    useEffect(() => {
        // Caut elementul cu textul "Apt" in dropdownul de aptitudini
        let _aptElement = aptitudineDropdown.find(element => element.text.toLowerCase() === "apt");
        if (_aptElement) {
            setAptId(_aptElement.id)
        }
    }, [aptitudineDropdown]);

    useEffect(() => {
        if (list.length > 0 && aptitudineDropdown.length > 0) {
            var d = [];
            for (var item in list) {
                var el = utils.findObjectById(aptitudineDropdown, list[item].idRezolutie)
                d.push(el);
            }
            setAptitudineDefaults(d);
        }
    }, [list, aptitudineDropdown]);
    




    // Dupa ce le aduc , setez defaulturile
    useEffect(() => {
        nomService.getMwRecomandations()
            .then(response => {
                if (response) {
                    setRecomandareDropdown(response);
                }
            });
    }, [list]);


    useEffect(() => {
        if (list.length > 0 && recomandareDropdown.length > 0) {
            var d = [];
            for (var item in list) {
                var el = utils.findObjectById(recomandareDropdown, list[item].idRecomandare)
                d.push(el);
            }
            setRecomandareDefaults(d);
            updateApt();
        }
    }, [list, recomandareDropdown]);


    const updateLists = (list) => {
        setList(list);
        props.setRecomandari(list)
        if (props.setIsModified) {
            props.setIsModified(true);
        }
    }

    const handleAdd = () => {
        const updatedList = [...list, newRow];
        updateLists(updatedList);
        setNewRow(row);
    };

    const handleChange = (event, index, field) => {
        const updatedList = [...list];
        var v = event.target.value;

        if (field == "idRezolutie") {
            if (v.text && v.text.toLowerCase() != "apt") {
                if (props.haveRestrictionDiagnostic == true) {
                    alertService.error( "Pentru oricare aviz medical cu exceptia APT nu se pot selecta diagnostice din grupele Z00 sau Z10!");
                    return;
                }
            }
            updateApt();
        }

        if (v && v.hasOwnProperty("id")){
            updatedList[index][field] = v.id;
        }
        else {
            updatedList[index][field] = v;
        }
        updateLists(updatedList);
     
        setSearchTerm("");
    };

    const updateApt = () => {
        if (aptId == null) {
            return;
        }

        // Daca n-am lista de recomandari sau n-am dropdownul de aptitudini, nu fac nimic
        if (list.length == 0) {
            // in caz ca se sterg elementele si lista ajunge cu zero elemente este apt
            props.setIsApt(true);
            return;
        }

        // caut in lista daca exista rezolutia cu valoarea diferita de aptId
        for (let i = 0; i < list.length; i++) {
            if (list[i].idRezolutie != aptId) {
                // Daca am gasit, setez isApt pe false si ies din functie
                props.setIsApt(false);
                return;
            }
        }

        // Daca nu am gasit, setez isApt pe true
        props.setIsApt(true);
        return;
    }


    const handleDelete = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta recomandare?"
            , () => {
                const updatedList = [...list];
                updatedList.splice(index, 1);
                updateLists(updatedList);
            }
            , () => { return; }
        );
        updateApt();
    };

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {
        let newList = [...list];
        newList[clickedIndex].idRecomandare = recomandareDropdown[item].id;
        updateLists(newList);
    }


    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };


    const filtred = searchTerm
        ? recomandareDropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : recomandareDropdown;

    return (
        <>
            <fieldset>
                <legend className="pt20 pb5">Concluzie</legend>
                <table className="tbl tbladd mt5" name="lista_recomandari" width="100%">
                    <thead>
                        <tr>
                            <th>Aptitudine</th>
                            <th>Recomandare</th>
                            <th>Comentariu</th>
                            {props.finalizare != 1 && rol!= 2 && <th width="50">Editeaza</th>} 
                            {props.finalizare != 1 && rol!= 2 &&  <th width="50">Sterge</th> }
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) => (
                            <tr key={index}>
                                <td className="w200">

                                    <DropDownList
                                        name="idRezolutie"
                                        data={aptitudineDropdown}
                                        value={aptitudineDefaults[index]}
                                        textField="text"
                                        dataItemKey="id"
                                        className="full"
                                        onChange={(event) =>
                                            handleChange(event, index, "idRezolutie")
                                        }

                                        disabled={props.finalizare == 1 || rol == 2}
                                    />
                                </td>
                                <td className="w200 ">
                                    <DropDownList className="full"
                                        name="idRecomandare"
                                        data={filtred}
                                        value={recomandareDefaults[index]}
                                        textField="text"
                                        dataItemKey="id"
                                        className="full"
                                        onChange={(event) =>
                                            handleChange(event, index, "idRecomandare")
                                        }
                                        disabled={props.finalizare == 1 || rol == 2}
                                        onFilterChange={handleFilterChange}
                                        filterable
                                    />

                                </td>
                                <td className="w300">
                                    <Input className="full"
                                        name="recomandare"
                                        value={item.recomandare ?? ""}
                                        onChange={(event) => handleChange(event, index, "recomandare")}
                                        disabled={props.finalizare == 1 || rol == 2}
                                    />
                                </td>

                                {props.finalizare != 1 && rol != 2 &&
                                    <td className="center" name="recomandare_edit" onClick={() => handleClick(index)}  >
                                        <span className="icon modifica center"></span>
                                    </td>
                                }
                                
                                {props.finalizare != 1 && rol != 2 &&
                                    <td className="center" name="recomandare_del" onClick={() => handleDelete(index)}>
                                        <span className="icon sterge center"></span>
                                    </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>

                {!props.finalizare && rol != 2 && (
                    <button name="adauga_recomandare" className="btn mt10" onClick={handleAdd}>Adauga recomandare</button>
                )}


            </fieldset>

            {
                showDialog && <ListDialog title="Recomandari"
                    data={recomandareDropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }
        </>
    );
}